<template>
  <section class="p-2">
    <v-card>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form v-model="valid" ref="filter">
            <v-row class="ma-0 ms-0">
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  v-model="selectedCountry"
                  class="rounded"
                  dense
                  outlined
                  hide-details
                  label="Sender Country"
                  item-text="txt"
                  item-value="val"
                  :items="senderCountrys"
                  :rules="FieldRequired('Sender Country')"
                  placeholder="Sender Country"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  v-model="payselectedCountry"
                  class="rounded"
                  dense
                  outlined
                  hide-details
                  label="Payout Country"
                  item-text="txt"
                  item-value="val"
                  :items="countryOptions"
                  :rules="FieldRequired('Payout Country')"
                  placeholder="Payout Country"
                ></v-autocomplete>
              </v-col>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-1 text-decoration-none"
                color="primary"
                @click="getAllRates()"
                >Get Results</v-btn
              >
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>

      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="RatesSummary"
        :search="search"
        dense
        show-select
        v-model="selectedData"
        item-key="rate_id"
      >
        <template v-slot:item.exchange_markup="{ item }">
          <div class="d-flex">
            {{ item.exchange_markup }}
            <div v-if="item.markup_type == 'Flat'"></div>
            <div v-else>%</div>
          </div>
        </template>
        <template v-slot:item.ho_margin="{ item }">
          <v-text-field
            v-model="item.ho_margin"
            class="rounded ma-1"
            type="number"
            hide-spin-buttons
            @input="calculateExRtae(item.rate_id, true, item)"
            dense
            outlined
            title="HO Margin"
            hide-details
            placeholder="HO Margin"
            :rules="FieldNumbRequired('HO Margin')"
          ></v-text-field>
        </template>
        <template v-slot:item.agent_margin="{ item }">
          <div class="d-flex align-center">
            <v-text-field
              v-model="item.agent_margin"
              class="rounded ma-1"
              type="number"
              title="Agent Margin"
              hide-spin-buttons
              @input="calculateExRtae(item.rate_id, false, item)"
              dense
              outlined
              hide-details
              placeholder="Agent Margin"
              :rules="FieldNumbRequired('Agent Margin')"
            ></v-text-field>

            <span class="ml-2">
              {{ item?.agent_margin_type ? item?.agent_margin_type : "F" }}
            </span>
          </div>
        </template>
        <template v-slot:item.txn_rate="{ item }">
          <v-text-field
            v-model="item.txn_rate"
            class="rounded"
            type="number"
            hide-spin-buttons
            @input="calculateTxnrate(item.rate_id, item)"
            dense
            outlined
            hide-details
            title="Txn Rate"
            placeholder="Txn Rate"
            :rules="FieldNumbRequired('Txn Rate')"
          ></v-text-field>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-icon
              small
              title="Update"
              color="primary"
              class="mr-2"
              @click="UpdateRateData()"
            >
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              title="Delete"
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </div>
        </template>

        <template v-slot:top>
          <div class="d-flex mt-3">
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-2 text-decoration-none"
              color="primary"
              @click="openDialog()"
              ><v-icon small>mdi-plus</v-icon>Add</v-btn
            >
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-2 text-decoration-none"
              color="primary"
              @click="UpdateRateData()"
              ><v-icon small> mdi-content-save-edit-outline</v-icon>Update
              All</v-btn
            >
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              color="primary"
              small
              class="me-5 mt-2"
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-3"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="500">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="#050048" dark flat dense>
              <span>{{ formtitle }} Exchange Rates</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required">
                    Sending Country
                  </label>
                  <v-autocomplete
                    v-model="RatesDetails.send_country"
                    class="rounded"
                    dense
                    outlined
                    :disabled="RatesDetails.id"
                    item-text="txt"
                    item-value="val"
                    :items="senderCountrys"
                    :rules="FieldRequired('Sender Country')"
                    @input="getSendCountryPartners(RatesDetails.send_country)"
                    placeholder="Sender Country"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required">
                    Channel Partner
                  </label>
                  <v-autocomplete
                    v-model="RatesDetails.send_partner"
                    class="rounded"
                    dense
                    outlined
                    :disabled="RatesDetails.id"
                    item-text="txt"
                    item-value="val"
                    :items="senderPartners"
                    :rules="FieldRequired('Channel Partner')"
                    placeholder="Partner"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required">
                    Payout Country
                  </label>
                  <v-autocomplete
                    v-model="RatesDetails.payout_country"
                    class="rounded"
                    dense
                    outlined
                    :disabled="RatesDetails.id"
                    placeholder="Country"
                    item-text="txt"
                    item-value="val"
                    :items="countryOptions"
                    :rules="FieldRequired('Payout Country')"
                    @input="
                      getPayoutCountryPaymentModes(RatesDetails.payout_country)
                    "
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required"> Currency </label>
                  <v-text-field
                    v-model="RatesDetails.currency"
                    class="rounded"
                    dense
                    outlined
                    :disabled="RatesDetails.id"
                    placeholder="Currency"
                    :rules="FieldRequired('Currency')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize"> Payment Mode </label>
                  <v-autocomplete
                    v-model="RatesDetails.payment_mode"
                    class="rounded"
                    dense
                    outlined
                    :disabled="RatesDetails.id"
                    placeholder=" Payment Mode"
                    item-text="txt"
                    item-value="val"
                    :items="paymentModesList"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="pa-0 mb-0"></v-divider>
            <v-card-actions class="ma-0 pt-0">
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                @click="submitData()"
                ><v-icon small>mdi-content-save-plus-outline</v-icon>Submit
              </v-btn>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                outlined
                @click="closeDialog()"
                ><v-icon small>mdi-close</v-icon>cancel
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete ?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteExchangeRate()"
            >
              Delete<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteDialog = false"
            >
              Close<v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import setupService from "@/services/SetupService/setupService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "Master Bank Summary",
  data() {
    return {
      FieldRequired,
      FieldNumbRequired,
      filterNumberInput,
      search: "",
      loader: false,
      showDialog: false,
      showRateDialog: false,
      deleteDialog: false,
      selcted_currency: null,
      selcted_rate_id: null,
      valid: true,
      deleteId: null,
      editedIndex: -1,
      selectedCountry: "MYS",
      payselectedCountry: "",
      countryOptions: [],
      docs_LIST: [],
      senderCountrys: [],
      selectedData: [],
      senderPartners: [],
      paymentModesList: [],
      selectedCurrency: "INR",
      dropdown: {
        country_objs: [],
      },

      RatesSummary: [],
      RatesDetails: {
        send_partner: "",
        send_country: "",
        payout_country: "",
        payment_mode: "",
        currency: "",
        rate_level: "CW",
        txn_type: "IND",
      },
      update_cost_rate: {
        cost_rate: 0,
        ho_margin: 0,
        settlement_rate: 0,
        agent_margin: 0,
        txn_rate: 0,
      },
    };
  },
  components: {
    OverlayPageVue,
  },
  watch: {
    "RatesDetails.payout_country"(val) {
      this.dropdown.country_objs.map((ele) => {
        if (ele.iso_alpha3 === val) {
          this.RatesDetails.currency = ele.currency_code;
        }
      });
    },
    selectedData(val) {
      console.log("Selected Data value===> ", val);
    },
  },
  mounted() {
    this.getcountryList();
    this.getAllSendCountrys();
    // this.getAllRates();
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    dessertHeaders() {
      return [
        {
          text: `Sending Agent`,
          sortable: false,
          value: "sending_partner",
        },
        { text: "Country", value: "payout_name", sortable: false },
        { text: "Payment Mode", value: "payment_mode", sortable: false },
        {
          text: `Cost Rate (${this.selectedCurrency})`,
          value: "cost_rate",
          sortable: false,
        },
        {
          text: `HO Margin (${this.selectedCurrency})`,
          value: "ho_margin",
          sortable: false,
          width: "150px",
        },
        {
          text: `Settlement Rate (${this.selectedCurrency})`,
          value: "settlement_rate",
          sortable: false,
        },
        {
          text: `Agent Margin (${this.selectedCurrency})`,
          value: "agent_margin",
          sortable: false,
          width: "150px",
        },
        {
          text: `Txn Rate (${this.selectedCurrency})`,
          value: "txn_rate",
          sortable: false,
          width: "150px",
        },
        // {
        //   text: `Modified Rate`,
        //   value: "txn_rate",
        //   sortable: false,
        //   width: "150px",
        // },
        { text: "Action", value: "action", sortable: false, width: "100px" },
      ];
    },
  },
  methods: {
    async getAllRates() {
      const validate = this.$refs.filter.validate();
      if (validate) {
        this.loader = true;
        try {
          const response = await setupService.getAllExchangeRates({
            rate_level: "CW",
            send_country: this.selectedCountry,
            pay_country: this.payselectedCountry,
            txn_type: "IND",
          });
          if (response.data.status_code === 200) {
            this.RatesSummary = response.data.data;
            this.dropdown.country_objs.map((ele) => {
              if (ele.iso_alpha3 === this.payselectedCountry) {
                this.selectedCurrency = ele.currency_code;
              }
            });
            console.log("Rates Data", this.RatesSummary);
            this.stoploader();
          } else {
            this.RatesSummary == [];
            this.stoploader();
          }
        } catch (error) {
          this.RatesSummary = [];
          this.stoploader();
          console.error(error);
        }
      }
    },

    submitData() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.RatesDetails.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },
    async save() {
      try {
        const response = await setupService.addExchageRate(this.RatesDetails);
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.showDialog = false;
          this.getAllRates();
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async UpdateRateData() {
      if (this.RatesSummary.length > 0 && this.selectedData.length > 0) {
        this.loader = true;
        const payloadData = this.selectedData.map((ele) => {
          return {
            cost_rate: ele.cost_rate,
            ho_margin: ele.ho_margin,
            settlement_rate: ele.settlement_rate,
            agent_margin: ele.agent_margin,
            payment_mode: ele.payment_mode_code,
            txn_rate: ele.txn_rate,
            rate_id: ele.rate_id,
          };
        });
        try {
          const response = await setupService.updateExchangeRate(payloadData);
          if (response.data.status_code === 200) {
            this.showAlertSuccess(response.data.message);
            this.selectedData = [];
            this.stoploader();
            this.getAllRates();
          } else {
            this.showAlertError(response.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.error(error);
          this.stoploader();
        }
      }
    },

    async calculateExRtae(id, is_homargin, item) {
      this.update_cost_rate = item;
      try {
        const response = await setupService.calculateExRtae(
          id,
          this.update_cost_rate,
        );
        if (response.data.status_code === 200) {
          if (is_homargin) {
            this.update_cost_rate.settlement_rate =
              response.data.data[0].settlement_rate;
            this.update_cost_rate.txn_rate = response.data.data[0].txn_rate;
          } else {
            this.update_cost_rate.txn_rate = response.data.data[0].txn_rate;
          }
          // this.showAlertSuccess(response.data.message);

          this.showDialog = false;
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },

    async calculateTxnrate(id, item) {
      this.update_cost_rate = item;
      try {
        const response = await setupService.calculateTxnrate(
          id,
          this.update_cost_rate,
        );
        if (response.data.status_code === 200) {
          this.update_cost_rate.settlement_rate =
            response.data.data[0].settlement_rate;
          this.update_cost_rate.ho_margin = response.data.data[0].ho_margin;
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },

    deleteItem(item) {
      this.deleteDialog = true;
      this.deleteId = item.rate_id;
    },

    async delete() {
      try {
        const response = await setupService.deleteExchangeRate(this.deleteId);
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.deleteDialog = false;
          this.getAllRates();
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },

    deleteExchangeRate() {
      this.delete();
    },

    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.countryOptions = response.data.data.map((i) => {
            return { txt: i.name, val: i.iso_alpha3 };
          });
        }
        this.dropdown.country_objs = response.data.data;
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.countryOptions = [];
      }
    },
    async getAllSendCountrys() {
      try {
        const responseData = await partnerService.getAllSenderCountrys();
        if (responseData.data.status_code === 200) {
          this.senderCountrys = responseData.data.data.map((i) => {
            return { txt: i.name, val: i.iso3 };
          });
        }
        console.log("Send Countrys", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getSendCountryPartners(country_code) {
      try {
        const responseData = await partnerService.getCountryPartners(
          country_code,
        );
        if (responseData.data.status_code === 200) {
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
        console.log("Partners", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getPayoutCountryPaymentModes(country_code) {
      try {
        const responseData = await setupService.getpaymentmodeBycntry(
          country_code,
        );
        if (responseData.data.status_code === 200) {
          this.paymentModesList = responseData.data.data.map((i) => {
            return {
              txt: i.payment_type.payment_mode,
              val: i.payment_type.payment_mode_code,
            };
          });
        }
        console.log("Partners", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.RatesSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.RatesSummary,
          "RatesSummary",
        );
      }
    },

    openDialog() {
      this.editedIndex = -1;
      this.showDialog = true;
      this.resetRatesDetailsObj();
      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
      }
      if (this.selectedCountry) {
        this.getSendCountryPartners(this.selectedCountry);
        this.RatesDetails.send_country = this.selectedCountry;
      }
      if (this.payselectedCountry) {
        this.getPayoutCountryPaymentModes(this.payselectedCountry);
        this.RatesDetails.payout_country = this.payselectedCountry;
      }
    },
    resetRatesDetailsObj() {
      this.RatesDetails.id = null;
      this.RatesDetails.send_partner = null;
      this.RatesDetails.payout_country = "";
      this.RatesDetails.send_country = "";
      this.RatesDetails.payment_mode = "";
      this.RatesDetails.rate_level = "CW";
      this.RatesDetails.txn_type = "IND";
    },

    closeDialog() {
      this.showDialog = false;
      this.$refs.Addform.resetValidation();
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";

.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
.apexcharts-toolbar {
  display: none !important;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
